'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _selectField = require('material-ui/lib/select-field');

var _selectField2 = _interopRequireDefault(_selectField);

var _menuItem = require('material-ui/lib/menus/menu-item');

var _menuItem2 = _interopRequireDefault(_menuItem);

var _reactSelect = require('react-select');

var _reactSelect2 = _interopRequireDefault(_reactSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BinarySelectField = function (_Component) {
  _inherits(BinarySelectField, _Component);

  function BinarySelectField(props) {
    _classCallCheck(this, BinarySelectField);

    var _this = _possibleConstructorReturn(this, (BinarySelectField.__proto__ || Object.getPrototypeOf(BinarySelectField)).call(this, props));

    _this.styles = require('./BinarySelectField.scss');
    _this.state = {
      value: _this.props.defaultValue
    };
    return _this;
  }

  _createClass(BinarySelectField, [{
    key: 'onChange',
    value: function onChange(value) {
      var tagsLength = value.length - 1;
      if (value.length > 0 && this.props.emailValidation) {
        var emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (emailRegex.test(value[tagsLength].value)) {
          this.props.onChange(value);
          this.setState({ value: value });
        } else {
          value.splice(tagsLength, 1);
          this.setState({ value: value });
        }
      } else {
        this.props.onChange(value);
        this.setState({ value: value });
      }
    }
  }, {
    key: 'getOptions',
    value: function getOptions() {
      var data = this.props.data;

      var DATA = [];
      if (data !== undefined) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var item = _step.value;

            var value = item.value ? item.value : item.id;
            var label = item.text ? item.text : item.name;
            var disabled = item.disabled !== undefined && item.disabled ? item.disabled : false;
            var customValue = item.customValue !== undefined && item.customValue ? item.customValue : false;
            DATA.push({ value: value, label: label, disabled: disabled, customValue: customValue });
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
      return DATA;
    }
  }, {
    key: 'getDropdownItems',
    value: function getDropdownItems() {
      var _props = this.props,
          data = _props.data,
          selected = _props.selected;

      var DATA = [];

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = data[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var item = _step2.value;

          var id = item.id ? item.id : item.text;
          DATA.push(_react2.default.createElement(_menuItem2.default, {
            key: Math.random(),
            value: item.value,
            className: selected === item.value ? this.styles.binary_dropdown_item_selected : this.styles.binary_dropdown_item,
            id: id ? (id + '').split(' ').join('_') : '',
            primaryText: item.text }));
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return DATA;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          selected = _props2.selected,
          style = _props2.style,
          border = _props2.border,
          multiselect = _props2.multiselect,
          disabled = _props2.disabled,
          onChange = _props2.onChange,
          hintText = _props2.hintText,
          custom = _props2.custom,
          customClassName = _props2.customClassName,
          allowCreate = _props2.allowCreate;

      var className = border ? this.styles.binary_dropdown : this.styles.binary_dropdown_noborder;
      var dropdownClass = this.props.dropdownClass ? this.props.dropdownClass : '';
      return _react2.default.createElement(
        'div',
        { style: style ? style : {}, className: className + ' ' + dropdownClass },
        !multiselect && !custom && !allowCreate && _react2.default.createElement(
          'div',
          { className: this.styles.binary_dropdown_single },
          _react2.default.createElement(
            _selectField2.default,
            {
              labelStyle: border ? {
                'lineHeight': '20px',
                'top': '0px',
                'color': '#4E4E4E',
                'fontSize': '14px'
              } : {
                'color': '#4E4E4E'
              },
              floatingLabelStyle: {
                bottom: '0px'
              },
              style: border ? {
                'width': '100%',
                'height': '20px',
                'lineHeight': '20px',
                'color': '#4E4E4E',
                'overflow': 'hidden'
              } : {
                'color': '#4E4E4E',
                'overflow': 'hidden',
                'fontSize': '15px'
              },
              underlineFocusStyle: {
                'color': '#4E4E4E',
                'backgroundColor': '#000'
              },
              selectedMenuItemStyle: {
                'color': '#FFF'
              },
              selectFieldRoot: border ? {} : {
                'color': '#FFF',
                'width': '100%'
              },
              underlineStyle: {
                'color': '#4E4E4E',
                'backgroundColor': '#000'
              },
              maxHeight: 250,
              fullWidth: false,
              autoWidth: this.props.autoWidth,
              disabled: disabled,
              value: selected,
              hintText: hintText,
              onChange: onChange.bind(this)
            },
            this.getDropdownItems()
          )
        ),
        multiselect && _react2.default.createElement(
          'div',
          { className: this.styles.binary_dropdown_multiple },
          _react2.default.createElement(_reactSelect2.default, {
            autosize: false,
            disabled: disabled,
            name: 'form-field-name',
            multi: true,
            key: this.state.key,
            joinValues: true,
            value: this.state.value,
            simpleValue: false,
            placeholder: hintText,
            options: this.getOptions(),
            onChange: this.onChange.bind(this),
            className: customClassName,
            clearable: false
          })
        ),
        custom && _react2.default.createElement(_reactSelect2.default, {
          autosize: false,
          disabled: disabled,
          key: this.state.key,
          clearable: false,
          name: 'form-field-name',
          value: selected ? selected : this.state.value,
          placeholder: hintText,
          options: this.getOptions(),
          onChange: this.onChange.bind(this),
          className: customClassName ? customClassName : this.styles.binary_custom_dropdown
        }),
        allowCreate && _react2.default.createElement(_reactSelect.Creatable, {
          multi: this.props.multi,
          disabled: disabled,
          key: this.state.key,
          clearable: false,
          options: this.getOptions(),
          name: 'form-field-name',
          value: selected ? selected : this.state.value,
          placeholder: hintText,
          onChange: this.onChange.bind(this),
          className: customClassName ? customClassName : this.styles.binary_custom_dropdown,
          promptTextCreator: function promptTextCreator(label) {
            return label + ' ';
          }
        })
      );
    }
  }]);

  return BinarySelectField;
}(_react.Component);

BinarySelectField.propTypes = {
  disabled: _propTypes2.default.bool,
  border: _propTypes2.default.bool,
  hintText: _propTypes2.default.string,
  multiselect: _propTypes2.default.bool,
  defaultValue: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.number]),
  data: _propTypes2.default.array.isRequired, // value, id, text
  onChange: _propTypes2.default.func.isRequired,
  selected: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  autoWidth: _propTypes2.default.bool,
  custom: _propTypes2.default.bool,
  style: _propTypes2.default.object,
  customClassName: _propTypes2.default.string,
  dropdownClass: _propTypes2.default.string,
  allowCreate: _propTypes2.default.bool,
  emailValidation: _propTypes2.default.bool,
  multi: _propTypes2.default.bool
};
BinarySelectField.defaultProps = {
  selected: 1,
  hintText: '',
  multiselect: false,
  defaultValue: [],
  border: true,
  disabled: false,
  autoWidth: true,
  custom: false,
  allowCreate: false,
  emailValidation: false,
  multi: false
};
exports.default = BinarySelectField;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Binary/BinarySelectField/BinarySelectField.js
// module id = 2172
// module chunks = 1